import { render, staticRenderFns } from "./Soccer.vue?vue&type=template&id=33fde1ca&scoped=true&"
import script from "./Soccer.vue?vue&type=script&lang=js&"
export * from "./Soccer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fde1ca",
  null
  
)

export default component.exports